import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;

  @media(max-width: 900px) {
    justify-content: center;
    align-items: center;
  }

  position: relative;
  top: 25%;
  transform: translateY(12%);
  margin: 0 3em;
  background: ${({ theme }) => theme.colors.lighterBackground};
  box-shadow: 8px 4px 10px rgba(0, 0, 0, 0.04);
  border-radius: 10px;
  margin-top: -48px;

  div.asideGif {
    /* padding: 60px; */
    @media(max-width: 900px) {
      display: none;
    }
    width: 37%;
    img {
      padding: 80px;
      padding-top: 120px;
      width: 100%;
      border-radius: 10px 0px 0px 10px;
    }
  }

  div.asideLogin {
    margin: 2em 3em;
    margin-left: 0;
    width: 60%;
    @media(max-width: 900px) {
      margin: 1.5em;
      width: 90%;
    }

    .loginTitle {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 0.1em;
      @media(max-width: 900px) {
        flex-direction: column-reverse;
        justify-content: space-between;
        align-items: flex-start;
        margin-bottom: 0em !important;
      }
      img {
        width: 200px;
        @media(max-width: 900px) {
          margin-bottom: 1em !important;
          width: 40%;
        }
      }
      .labelTitle {
        display: flex;
        flex-direction: column;
        div {
          font-size: 24px;
          font-weight: bold;
          @media(max-width: 500px) {
            font-size: 16px;
          }
        }
        .subtitle {
          font-size: 16px;
          font-weight: normal;
          @media(max-width: 500px) {
            font-size: 12px;
          }
        }
      }
    }

    .loginForm {
      margin-top: 1.5em;
      margin-bottom: 2em;
      max-height: 366px;
      overflow: auto;
      padding-right: 8px;

      .loginInput {
        margin-bottom: 15px;
        width: 100%;
      }

      .aside {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        gap: 16px;
      }

      .dataGroup {
        div.title {
          font-size: 18px;
          font-weight: semi-bold;
          margin: 24px 0px 8px 0px;

          display: flex;
          flex-direction: row;
          gap: 24px;
          align-items: center;
          justify-content: flex-start;
        }
      }
    }

    .backToLogin {
      text-align: center;
      text-decoration: underline;
      margin-top: 16px;

      a {
        &:hover{
        opacity: 0.5;
        transition: ease-in 0.2s;
      }
      &:not(:hover) {
        opacity: 1;
        transition: ease-in 0.2s;
      }
      }
    }
  }

`;
